import { FC, useState, useMemo, useEffect } from 'react';
import FilingsTable from '../components/FilingsTable';
import Filters from '../components/Filters';
import PaginationBtns from '../components/PaginationBtns';
import { ITEMS_PER_PAGE } from '../constants';
import { convertAndMapXmlFilingsData } from '../helpers';
import {
  useGetFilteredFilingsArrAndPageCount,
  useGetFiltersOptions,
} from '../hooksHelpers';
import { IFiling, IFilters } from '../types';

interface IProps {}

const Filings: FC<IProps> = () => {
  const [filingsArr, setFilingsArr] = useState<IFiling[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = '/wp-json/sw/v1/financials';
    fetch(url)
      .then(response => response?.text())
      .then(response => {
        if (response) {
          const filings = convertAndMapXmlFilingsData(response);
          setFilingsArr(filings);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const [activeFilters, setActiveFilters] = useState<IFilters>({
    year: null,
    filingType: null,
  });
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  const { filteredFilingsArr, pagesCount } =
    useGetFilteredFilingsArrAndPageCount(filingsArr, activeFilters);

  const { yearsOptions, filingTypesOptions } = useGetFiltersOptions(filingsArr);

  const currentPageArr = useMemo(() => {
    const startPointer = (currentPageNumber - 1) * ITEMS_PER_PAGE;
    const endPointer = startPointer + ITEMS_PER_PAGE;
    const arr = filteredFilingsArr.slice(startPointer, endPointer);
    return arr;
  }, [filteredFilingsArr, currentPageNumber]);

  const currentPageYears = useMemo(
    () =>
      Array.from(new Set(currentPageArr.map(filing => filing.year))).join(', '),
    [currentPageArr],
  );
  useEffect(() => {
    currentPageNumber > pagesCount && setCurrentPageNumber(1);
  }, [pagesCount, currentPageNumber]);

  const onPageChange = (clickedPageNumber: number) => () => {
    setCurrentPageNumber(clickedPageNumber);
  };

  return (
    <>
      <h3 className="wp-title" id="sec-filings">
        SEC<span>Filings</span>
      </h3>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <>
          <Filters
            yearsOptions={yearsOptions}
            filingTypesOptions={filingTypesOptions}
            onFilingTypeChange={value =>
              setActiveFilters(prevValue => ({
                ...prevValue,
                filingType: value,
              }))
            }
            onYearChange={value =>
              setActiveFilters(prevValue => ({ ...prevValue, year: value }))
            }
          />
          <div className="filings__years--container">{currentPageYears}</div>
          {pagesCount === 0 ? (
            <div className="filings__not-found">No filings found</div>
          ) : (
            <FilingsTable filingsArr={currentPageArr}>
              <PaginationBtns
                pagesCount={pagesCount}
                currentPageNumber={currentPageNumber}
                onPageChange={onPageChange}
              />
            </FilingsTable>
          )}
        </>
      )}
    </>
  );
};

export default Filings;
